import React, {useState, useContext, useEffect} from 'react';
import {Row, Spinner, Button, Pagination } from 'react-bootstrap';
import { AppContext } from '../../App';

export const Renew=(props)=>{
	const { expired } = useContext(AppContext);
	const [ pageCount, setPageCount ] = useState(0);
	const [ currentPage, setCurrentPage ] = useState(0);
	const [ pageArr, setPageArr ] = useState();
	const [ pageArrIndex, setPageArrIndex ] = useState(0);
	useEffect(()=>{
		if (expired!==undefined) {
			setPageArr(Object.keys(expired));
			let len = Object.keys(expired).length;
			setPageCount(Math.ceil(len/6));
		}
	},[expired]);
	const next=(key)=>{		
		if (pageArrIndex+key<pageCount) {
			setPageArrIndex(prev=>(prev+key));
		}
	}
	const prev=(key)=>{
		if (pageArrIndex-key>=0) {
			setPageArrIndex(prev=>(prev-key));
		}
	}
	const [ spageCount, setsPageCount ] = useState(0);
	const [ currentsPage, setCurrentsPage ] = useState(0);
	const [ spageArr, setsPageArr ] = useState();
	const [ spageArrIndex, setsPageArrIndex ] = useState(0);
	useEffect(()=>{
		if (props.search!==undefined) {
			let len = Object.keys(props.search).length;
			setsPageArr(Object.keys(props.search));
			setsPageCount(Math.ceil(len/6));
		}
	},[props.search]);
	const snext=(key)=>{		
		if (spageArrIndex+key<spageCount) {
			setsPageArrIndex(prev=>(prev+key));
		}
	}
	const sprev=(key)=>{
		if (spageArrIndex-key>=0) {
			setsPageArrIndex(prev=>(prev-key));
		}
	}
	return(
		expired!==undefined?(
			Object.keys(expired).length>0?(
					props.search!==undefined&&Object.keys(props.search).length>0?(
						<Row className="mx-0" >
							{
								Object.keys(props.search).map((renew,r_i)=>(
									spageCount!==undefined&&r_i>=currentsPage&&r_i<currentsPage+6?(
									<div className="bdrb2 renew-item py-2 px-3" key={`account_${r_i}`} >
										<div>
											{
												props.search[renew].license_status?(
													<span className="sucess-tag" ><i className="bi bi-check-circle-fill"></i> Active </span>
													):(
													<span className="error-tag" ><i className="bi bi-exclamation-circle-fill"></i> Inactive </span>
													)
											}
											<span className="tp1 f18 px-2" >{props.search[renew].account_name}</span><br />
											<span className="tp2 f14">Expiry Date : {props.search[renew].expiry_date},</span>
											<span onClick={()=>{props.details(renew)}} className="f14 text-primary c-point"> Contact details</span>
											{
								        		props.search[renew].days_remaining<=0?(
								        			<span className="expire-tag mx-2">Expired</span>
								        		):props.search[renew].days_remaining<30?(
								        			<span className="expire-tag mx-2">Expire in {props.search[renew].days_remaining} days.</span>
								        		):''
								        	}
										</div>
										<div className="d-grid" >
										{
											props.renewLoad&&props.rid!==undefined&&props.rid===renew?(
													<Button className="btn-t1-r self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
												):(
													<Button onClick={()=>{
													props.renewAccount(renew,props.search[renew].account_name);
											}} className="btn-t1-r self-center">Renew</Button>
											)
										}
										</div>
										<div className="d-grid" >
										{
											props.search[renew].license_status?(
												props.disLoad&&props.did!==undefined&&props.did===renew?(
													<Button className="btn-t1-r self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
												):(
													<Button onClick={()=>{
													props.disAcc(renew,props.search[renew].account_name);
													}} className="btn-disable self-center">Disable</Button>
												)
											):(
												props.enableLoad&&props.enableId!==undefined&&props.enableId===renew?(
													<Button className="btn-enable self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
												):(
													<Button onClick={()=>{
														props.enable(renew,props.search[renew].account_name)
													}} className="btn-enable self-center">Enable</Button>
												)
											)
										}
										</div>
									</div>
									):''
								))
							}
							<div className='pagination-wrap d-grid mt-3'>
								<Pagination>
							      <Pagination.First onClick={()=>{setsPageArrIndex(0)}} />
							      <Pagination.Prev onClick={()=>{sprev(10)}} />
							      {
								      spageCount!==undefined&&spageArr!==undefined?(
										 spageArr.map((c,ci)=>(
										 	ci<spageCount?(
											 		ci>=spageArrIndex&&ci<spageArrIndex+10?(
												 		currentsPage===ci*6?(
												 			<Pagination.Item key={`page_item_${ci}`} onClick={()=>{setCurrentsPage(ci*6)}} active>{ci+1}</Pagination.Item>
												 		):(
												 			<Pagination.Item key={`page_item_${ci}`} onClick={()=>{setCurrentsPage(ci*6)}} >{ci+1}</Pagination.Item>
												 		)
												 	):''
										 		):''
										 	))
									   ):''
							      }
							      <Pagination.Next onClick={()=>{snext(10)}} />
							      <Pagination.Last onClick={()=>{setsPageArrIndex(Math.ceil(spageCount/10))}}  />
							    </Pagination>
						    </div>
						</Row>
						):(
						<Row className="mx-0" >
							{
								Object.keys(expired).map((renew,r_i)=>(
									pageCount!==undefined&&r_i>=currentPage&&r_i<currentPage+6?(
									<div className="bdrb2 renew-item py-2 px-3" key={`account_${r_i}`} >
										<div>
											{
												expired[renew].license_status?(
													<span className="sucess-tag" ><i className="bi bi-check-circle-fill"></i> Active </span>
													):(
													<span className="error-tag" ><i className="bi bi-exclamation-circle-fill"></i> Inactive </span>
													)
											}
											<span className="tp1 f18 px-2" >{expired[renew].account_name}</span><br />
											<span className="tp2 f14">Expiry Date : {expired[renew].expiry_date},</span>
											<span onClick={()=>{props.details(renew)}} className="f14 text-primary c-point"> Contact details</span>
											{
								        		expired[renew].days_remaining<=0?(
								        			<span className="expire-tag mx-2">Expired</span>
								        		):expired[renew].days_remaining<30?(
								        			<span className="expire-tag mx-2">Expire in {expired[renew].days_remaining} days.</span>
								        		):''
								        	}
										</div>
										<div className="d-grid" >
										{
											props.renewLoad&&props.rid!==undefined&&props.rid===renew?(
													<Button className="btn-t1-r self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
												):(
													<Button onClick={()=>{
													props.renewAccount(renew,expired[renew].account_name);
											}} className="btn-t1-r self-center">Renew</Button>
											)
										}
										</div>
										<div className="d-grid" >
										{
											expired[renew].license_status?(
												props.disLoad&&props.did!==undefined&&props.did===renew?(
													<Button className="btn-t1-r self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
												):(
													<Button onClick={()=>{
													props.disAcc(renew,expired[renew].account_name);
													}} className="btn-disable self-center">Disable</Button>
												)
											):(
												props.enableLoad&&props.enableId!==undefined&&props.enableId===renew?(
													<Button className="btn-enable self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
												):(
													<Button onClick={()=>{
														props.enable(renew,expired[renew].account_name)
													}} className="btn-enable self-center">Enable</Button>
												)
											)
										}
										</div>
									</div>
									):''
								))
							}
							<div className='pagination-wrap d-grid mt-3'>
								<Pagination>
							      <Pagination.First onClick={()=>{setPageArrIndex(0)}} />
							      <Pagination.Prev onClick={()=>{prev(10)}} />
							      {
								      pageCount!==undefined&&pageArr!==undefined?(
										 pageArr.map((c,ci)=>(
										 	ci<pageCount?(
											 		ci>=pageArrIndex&&ci<pageArrIndex+10?(
												 		currentPage===ci*6?(
												 			<Pagination.Item key={`page_item_${ci}`} onClick={()=>{setCurrentPage(ci*6)}} active>{ci+1}</Pagination.Item>
												 		):(
												 			<Pagination.Item key={`page_item_${ci}`} onClick={()=>{setCurrentPage(ci*6)}} >{ci+1}</Pagination.Item>
												 		)
												 	):''
										 		):''
										 	))
									   ):''
							      }
							      <Pagination.Next onClick={()=>{next(10)}} />
							      <Pagination.Last onClick={()=>{setPageArrIndex(Math.ceil(pageCount/10))}}  />
							    </Pagination>
						    </div>
						</Row>
						)
				):(<span className="tp3 p-3" >Nothing to renew.</span>)
			):(<span className="tp3 p-3" >Fetching data...</span>)
		)
}